var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCourseMenuJournalLocked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.37987 15.04L5.18493 11.6989C5.44118 11.4789 5.81869 11.4789 6.07493 11.6989L9.88 15.04C10.0787 15.2137 10.3613 15.2562 10.6025 15.1475C10.8438 15.0387 10.9987 14.7987 11 14.535V1.47526C11 1.29651 10.93 1.124 10.8025 0.99651C10.6763 0.87026 10.5038 0.799012 10.325 0.80026H0.934875C0.756125 0.79901 0.583622 0.87026 0.457381 0.99651C0.329883 1.12401 0.259883 1.29651 0.259883 1.47526V14.5251C0.257383 14.7914 0.411134 15.0339 0.653643 15.1451C0.894894 15.2564 1.17988 15.2151 1.37988 15.0401L1.37987 15.04Z",
    fill: "#CCCCCC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseMenuJournalLocked);
export default __webpack_public_path__ + "static/media/course_menu_journal_locked.fedd0088e33e5ccd71cf140a950178a2.svg";
export { ForwardRef as ReactComponent };